export const GET_TOP_COMPANIES_RECIEVE = 'GET_TOP_COMPANIES_RECIEVE';
export const GET_TOP_COMPANIES_REQUEST = 'GET_TOP_COMPANIES_REQUEST';
export const HIDE_TOP_COMPANIES = 'HIDE_TOP_COMPANIES';
export const RESET_TOP_COMPANIES_RECIEVE = 'RESET_TOP_COMPANIES_RECIEVE';
export const SHARE_CANDIDATE_REQUEST = 'SHARE_CANDIDATE_REQUEST';
export const SHARE_CANDIDATE_RECIEVE = 'SHARE_CANDIDATE_RECIEVE';
